
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CreditCard, LinkIcon } from 'lucide-react';
import { useTranslations } from 'use-intl';

interface NoBankAccountsPlaceholderProps {
  onOpenConnectDialog: () => void;
}

const NoBankAccountsPlaceholder = ({ onOpenConnectDialog }: NoBankAccountsPlaceholderProps) => {
  const t = useTranslations('consultantBank.accounts.empty');
  return (
    <Card className="glass-card bg-accent/30">
      <CardContent className="flex flex-col items-center justify-center py-16">
        <div className="rounded-full bg-primary/10 p-3 mb-4">
          <CreditCard className="h-8 w-8 text-primary" />
        </div>
        <h3 className="text-lg font-semibold text-foreground">{t('title')}</h3>
        <p className="text-muted-foreground text-sm mb-6 text-center max-w-md">
          {t('body')}
        </p>
        <Button 
          variant="outline" 
          onClick={onOpenConnectDialog}
          className="flex items-center gap-2 border-primary text-primary hover:bg-primary/10"
        >
          <LinkIcon size={16} />
          {t('connect')}
        </Button>
      </CardContent>
    </Card>
  );
};

export default NoBankAccountsPlaceholder;
